(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

const headerWrapper = document.getElementById("HeaderWrapper");
const header = document.getElementById("shopify-section-header");
const body = document.getElementById("MainContent");
const overlay = document.querySelector(".header__overlay");
const tabButton = document.querySelectorAll(".tabs__button");
const contents = document.querySelectorAll(".tabs__content");
const mobileMenuIcon = document.querySelector(".header__mobile--open");
const mobileMenuButtons = document.querySelectorAll(".mobile__main__menu__link");
const mobileMenuMainContent = document.querySelector(".header__mobile__main");
const mobileSubMenus = document.querySelectorAll(".mobile__dropdown__menu__link");
const backToMainMenuButtons = document.querySelectorAll(".mobile__dropdown__wrapper--back");
const closeMobileMenuButtons = document.querySelectorAll(".header__mobile--close");
const openRightDrawer = document.querySelectorAll(".open__right__drawer");
const closeRightDrawer = document.querySelectorAll(".right__drawer--close");
const rightDrawerTogglers = document.querySelectorAll("[data-right-drawer-toggle]");
const rightDrawerRenderers = document.querySelectorAll("[data-right-drawer-renderer]");

tabButton.forEach((tab) => {
  tab.addEventListener("mouseenter", (e) => {

    // Clear hover state for other tabs
    tabButton.forEach((othertab) => {
      othertab.classList.remove('hover');
    });

    const listItem = e.currentTarget;
    const id = listItem.dataset.name;
    listItem.classList.add('hover');

    if (! id) 
      return;
    

    const element = document.getElementById(`${
      id.toLowerCase()
    }__dropdown`);
    contents.forEach((content) => {
      content.classList.remove("tabs__content--active");
    });
    if (!! element) {
      overlay.classList.add("visible");
      element.classList.add("tabs__content--active");
      const activeDropdown = document.querySelectorAll(".tabs__content--active");
      [
        header,
        activeDropdown[0]
      ].forEach((element) => {
        element.addEventListener("mouseleave", (e) => {
          listItem.classList.remove('hover');
          const contentsActive = document.querySelector(".tabs__content--active");
          if (contentsActive) {
            contentsActive.classList.remove("tabs__content--active");
            headerWrapper.classList.remove("navbar-active");
          }

          overlay.classList.remove("visible");
        });
      });
      headerWrapper.classList.add("navbar-active");
    } else {
      overlay.classList.remove("visible");
    }
  });
  tab.addEventListener("mouseleave", (e) => {
    tab.classList.remove('hover');
  })
});

mobileMenuIcon.addEventListener("click", function (e) {
  document.body.classList.add("mobile__menu--active");
  document.body.classList.add("no-scroll");
});

mobileMenuButtons.forEach((button) => {
  button.addEventListener("click", function (e) {
    const id = e.currentTarget.dataset.name;
    if (! id) 
      return;
    

    const element = document.querySelector(`#${
      id.toLowerCase()
    }__mobile__menu`);
    if (! element) 
      return;
    

    element.classList.add("header__mobile__dropdown__wrapper--active");
    mobileMenuMainContent.classList.add("header__mobile__main--child-active");
  });
});

backToMainMenuButtons.forEach((button) => {
  button.addEventListener("click", function (e) {
    const element = document.querySelector(".header__mobile__dropdown__wrapper--active");
    element.classList.remove("header__mobile__dropdown__wrapper--active");
    mobileMenuMainContent.classList.remove("header__mobile__main--child-active");
  });
});

closeMobileMenuButtons.forEach((button) => {
  button.addEventListener("click", function (e) {
    document.body.classList.remove("mobile__menu--active");
    document.body.classList.remove("no-scroll");
  });
});

mobileSubMenus.forEach((subMenu) => {
  subMenu.addEventListener("click", function (e) {
    const subMenuWrapper = e.currentTarget.parentElement;

    if (subMenuWrapper.classList.contains('mobile__dropdown__menu--active')) {
      subMenuWrapper.classList.remove("mobile__dropdown__menu--active");
      return;
    }

    const activeSubMenu = document.querySelector(".mobile__dropdown__menu--active");
    if (!! activeSubMenu) 
      activeSubMenu.classList.remove("mobile__dropdown__menu--active");
    

    subMenuWrapper.classList.add("mobile__dropdown__menu--active");
  });
});

openRightDrawer.forEach((button) => {
  setOpenDrawerListeners(button);
});

closeRightDrawer.forEach((button) => {
  button.addEventListener("click", function (e) {
    document.body.classList.remove("right__drawer--active");
    document.body.classList.remove("no-scroll");
  });
});

rightDrawerTogglers.forEach((button) => {
  button.addEventListener("click", function (e) {
    const togglerTarget = e.currentTarget.dataset.rightDrawerToggle;
    const togglerTargetContainer = document.querySelector(`[data-right-drawer-content="${togglerTarget}"]`);
    if (! togglerTargetContainer) 
      return;
    if (!document.body.classList.contains('right__drawer--active')) {
      document.body.classList.add("right__drawer--active");
      document.body.classList.add("no-scroll");
    }
    document.querySelector(".right__drawer__content--active").classList.remove("right__drawer__content--active");
    togglerTargetContainer.classList.add("right__drawer__content--active");
  });
});

document.querySelector('.js-ft-add')?.addEventListener("click", function (e) {
  document.querySelector('[data-right-drawer-content="favorite-teams-logged"]').classList.remove("right__drawer__content--active");
  const togglerTargetContainer = document.querySelector(`[data-right-drawer-content="favorite-teams-add-team"]`);
  togglerTargetContainer.classList.add("right__drawer__content--active");
});

window.addEventListener('DOMContentLoaded', (event) => {
  if (window.location.href.indexOf("#account-addresses") > -1) {
    renderRightDrawerType('account-addresses');
    document.body.classList.add("right__drawer--active");
    document.body.classList.add("no-scroll");
  }
});

 window.addEventListener('load', () => {
  const body = document.querySelector('body');
  const header = document.getElementById('shopify-section-header');

  header.addEventListener('mouseenter', () => {
    if (window.scrollY < 100) body.classList.remove('at-top');
  })

  header.addEventListener('mouseleave', () => {
    if (window.scrollY < 100) body.classList.add('at-top');
  })

  window.addEventListener('scroll', () => {
    if (window.scrollY > 100 && !body.classList.contains('at-top')) return;
    if (window.scrollY > 100) {
      body.classList.remove('at-top');
      return;
    }
    if (!body.classList.contains('at-top')) body.classList.add('at-top');
  })
})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["styles"]) return;
  try {
    
  var $stylesSlider = $('.js-styles-image-slider');

  /* ======= Product Slider ======= */

  $stylesSlider.slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    rows: 0,
    responsive: [{
      breakpoint: 1200,
      settings: {
        slidesToShow: 1.2,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        rows: 0
      }
    }]
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsio-workshop-overview"]) return;
  try {
    
  (function(){
    var countDownsAvailable = document.querySelectorAll('.ws-countdown');
    var loadScript = function(url, cb){
        var script = document.createElement('script');
        script.async = true;
        script.onerror = function() {
            console.log('workshop error loading script', url);
        };
        script.onload = cb;
        script.src = url;

        document.getElementsByTagName("head")[0].appendChild(script);
    };

    var initCountdowns = function($){
      !function(t){"use strict";var e=[],s=[],i={precision:100,elapse:!1,defer:!1};s.push(/^[0-9]*$/.source),s.push(/([0-9]{1,2}\/){2}[0-9]{4}( [0-9]{1,2}(:[0-9]{2}){2})?/.source),s.push(/[0-9]{4}([\/\-][0-9]{1,2}){2}( [0-9]{1,2}(:[0-9]{2}){2})?/.source),s=new RegExp(s.join("|"));var o={Y:"years",m:"months",n:"daysToMonth",d:"daysToWeek",w:"weeks",W:"weeksToMonth",H:"hours",M:"minutes",S:"seconds",D:"totalDays",I:"totalHours",N:"totalMinutes",T:"totalSeconds"};var n=function(s,o,n){this.el=s,this.$el=t(s),this.interval=null,this.offset={},this.options=t.extend({},i),this.firstTick=!0,this.instanceNumber=e.length,e.push(this),this.$el.data("tsiocountdown-instance",this.instanceNumber),n&&("function"==typeof n?(this.$el.on("update.tsiocountdown",n),this.$el.on("stoped.tsiocountdown",n),this.$el.on("finish.tsiocountdown",n)):this.options=t.extend({},i,n)),this.setFinalDate(o),!1===this.options.defer&&this.start()};t.extend(n.prototype,{start:function(){null!==this.interval&&clearInterval(this.interval);var t=this;this.update(),this.interval=setInterval(function(){t.update.call(t)},this.options.precision)},stop:function(){clearInterval(this.interval),this.interval=null,this.dispatchEvent("stoped")},toggle:function(){this.interval?this.stop():this.start()},pause:function(){this.stop()},resume:function(){this.start()},remove:function(){this.stop.call(this),e[this.instanceNumber]=null,delete this.$el.data().tsioCountdownInstance},setFinalDate:function(t){this.finalDate=function(t){if(t instanceof Date)return t;if(String(t).match(s))return String(t).match(/^[0-9]*$/)&&(t=Number(t)),String(t).match(/\-/)&&(t=String(t).replace(/\-/g,"/")),new Date(t);throw new Error("Couldn't cast `"+t+"` to a date object.")}(t)},update:function(){if(0!==this.$el.closest("html").length){var t,e=new Date;t=this.finalDate.getTime()-e.getTime(),t=Math.ceil(t/1e3),t=!this.options.elapse&&t<0?0:Math.abs(t),this.totalSecsLeft===t||this.firstTick?this.firstTick=!1:(this.totalSecsLeft=t,this.elapsed=e>=this.finalDate,this.offset={seconds:this.totalSecsLeft%60,minutes:Math.floor(this.totalSecsLeft/60)%60,hours:Math.floor(this.totalSecsLeft/60/60)%24,days:Math.floor(this.totalSecsLeft/60/60/24)%7,daysToWeek:Math.floor(this.totalSecsLeft/60/60/24)%7,daysToMonth:Math.floor(this.totalSecsLeft/60/60/24%30.4368),weeks:Math.floor(this.totalSecsLeft/60/60/24/7),weeksToMonth:Math.floor(this.totalSecsLeft/60/60/24/7)%4,months:Math.floor(this.totalSecsLeft/60/60/24/30.4368),years:Math.abs(this.finalDate.getFullYear()-e.getFullYear()),totalDays:Math.floor(this.totalSecsLeft/60/60/24),totalHours:Math.floor(this.totalSecsLeft/60/60),totalMinutes:Math.floor(this.totalSecsLeft/60),totalSeconds:this.totalSecsLeft},this.options.elapse||0!==this.totalSecsLeft?this.dispatchEvent("update"):(this.stop(),this.dispatchEvent("finish")))}else this.remove()},dispatchEvent:function(e){var s,i=t.Event(e+".tsiocountdown");i.finalDate=this.finalDate,i.elapsed=this.elapsed,i.offset=t.extend({},this.offset),i.strftime=(s=this.offset,function(t){var e,i,n,a,h,l,r=t.match(/%(-|!)?[A-Z]{1}(:[^;]+;)?/gi);if(r)for(var c=0,f=r.length;c<f;++c){var u=r[c].match(/%(-|!)?([a-zA-Z]{1})(:[^;]+;)?/),p=(e=u[0],i=e.toString().replace(/([.?*+^$[\]\\(){}|-])/g,"\\$1"),new RegExp(i)),d=u[1]||"",v=u[3]||"",g=null;u=u[2],o.hasOwnProperty(u)&&(g=o[u],g=Number(s[g])),null!==g&&("!"===d&&(a=g,h=void 0,l=void 0,h="s",l="",(n=v)&&(1===(n=n.replace(/(:|;|\s)/gi,"").split(/\,/)).length?h=n[0]:(l=n[0],h=n[1])),g=Math.abs(a)>1?h:l),""===d&&g<10&&(g="0"+g.toString()),t=t.replace(p,g.toString()))}return t=t.replace(/%%/,"%")}),this.$el.trigger(i)}}),t.fn.tsioCountdown=function(){var s=Array.prototype.slice.call(arguments,0);return this.each(function(){var i=t(this).data("tsiocountdown-instance");if(void 0!==i){var o=e[i],a=s[0];n.prototype.hasOwnProperty(a)?o[a].apply(o,s.slice(1)):null===String(a).match(/^[$A-Z_][0-9A-Z_$]*$/i)?(o.setFinalDate.call(o,a),o.start()):t.error("Method %s does not exist on jQuery.tsioCountdown".replace(/\%s/gi,a))}else new n(this,s[0],s[1])})}}($);

      $(function(){
        $('.ws-period time').each(function(){
		    var dateString = $(this).attr('datetime').replace(/\//g,'-') + 'T23:59:59.000';
			if(timezoneOffset){
				dateString += timezoneOffset;
			}
            var dateObj = new Date(dateString);
            $(this).tsioCountdown(dateObj, function(event) {
              $(this).html(event.strftime('%-Dd %Hh %Mm %Ss'));
            });
        });
      });
    };

    if(countDownsAvailable.length){
      if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.7)) {
        loadScript('//ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js', function(){
          jQueryTSIOWorkshop = jQuery.noConflict(true);
          initCountdowns(jQueryTSIOWorkshop);
        });
      } else {
        initCountdowns(jQuery);
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsio-workshop-product"]) return;
  try {
    
  (function(){
    var countDownsAvailable = document.querySelectorAll('.ws-countdown');
    var loadScript = function(url, cb){
        var script = document.createElement('script');
        script.async = true;
        script.onerror = function() {
            console.log('workshop error loading script', url);
        };
        script.onload = cb;
        script.src = url;

        document.getElementsByTagName("head")[0].appendChild(script);
    };

    var initCountdowns = function($){
      !function(t){"use strict";var e=[],s=[],i={precision:100,elapse:!1,defer:!1};s.push(/^[0-9]*$/.source),s.push(/([0-9]{1,2}\/){2}[0-9]{4}( [0-9]{1,2}(:[0-9]{2}){2})?/.source),s.push(/[0-9]{4}([\/\-][0-9]{1,2}){2}( [0-9]{1,2}(:[0-9]{2}){2})?/.source),s=new RegExp(s.join("|"));var o={Y:"years",m:"months",n:"daysToMonth",d:"daysToWeek",w:"weeks",W:"weeksToMonth",H:"hours",M:"minutes",S:"seconds",D:"totalDays",I:"totalHours",N:"totalMinutes",T:"totalSeconds"};var n=function(s,o,n){this.el=s,this.$el=t(s),this.interval=null,this.offset={},this.options=t.extend({},i),this.firstTick=!0,this.instanceNumber=e.length,e.push(this),this.$el.data("tsiocountdown-instance",this.instanceNumber),n&&("function"==typeof n?(this.$el.on("update.tsiocountdown",n),this.$el.on("stoped.tsiocountdown",n),this.$el.on("finish.tsiocountdown",n)):this.options=t.extend({},i,n)),this.setFinalDate(o),!1===this.options.defer&&this.start()};t.extend(n.prototype,{start:function(){null!==this.interval&&clearInterval(this.interval);var t=this;this.update(),this.interval=setInterval(function(){t.update.call(t)},this.options.precision)},stop:function(){clearInterval(this.interval),this.interval=null,this.dispatchEvent("stoped")},toggle:function(){this.interval?this.stop():this.start()},pause:function(){this.stop()},resume:function(){this.start()},remove:function(){this.stop.call(this),e[this.instanceNumber]=null,delete this.$el.data().tsioCountdownInstance},setFinalDate:function(t){this.finalDate=function(t){if(t instanceof Date)return t;if(String(t).match(s))return String(t).match(/^[0-9]*$/)&&(t=Number(t)),String(t).match(/\-/)&&(t=String(t).replace(/\-/g,"/")),new Date(t);throw new Error("Couldn't cast `"+t+"` to a date object.")}(t)},update:function(){if(0!==this.$el.closest("html").length){var t,e=new Date;t=this.finalDate.getTime()-e.getTime(),t=Math.ceil(t/1e3),t=!this.options.elapse&&t<0?0:Math.abs(t),this.totalSecsLeft===t||this.firstTick?this.firstTick=!1:(this.totalSecsLeft=t,this.elapsed=e>=this.finalDate,this.offset={seconds:this.totalSecsLeft%60,minutes:Math.floor(this.totalSecsLeft/60)%60,hours:Math.floor(this.totalSecsLeft/60/60)%24,days:Math.floor(this.totalSecsLeft/60/60/24)%7,daysToWeek:Math.floor(this.totalSecsLeft/60/60/24)%7,daysToMonth:Math.floor(this.totalSecsLeft/60/60/24%30.4368),weeks:Math.floor(this.totalSecsLeft/60/60/24/7),weeksToMonth:Math.floor(this.totalSecsLeft/60/60/24/7)%4,months:Math.floor(this.totalSecsLeft/60/60/24/30.4368),years:Math.abs(this.finalDate.getFullYear()-e.getFullYear()),totalDays:Math.floor(this.totalSecsLeft/60/60/24),totalHours:Math.floor(this.totalSecsLeft/60/60),totalMinutes:Math.floor(this.totalSecsLeft/60),totalSeconds:this.totalSecsLeft},this.options.elapse||0!==this.totalSecsLeft?this.dispatchEvent("update"):(this.stop(),this.dispatchEvent("finish")))}else this.remove()},dispatchEvent:function(e){var s,i=t.Event(e+".tsiocountdown");i.finalDate=this.finalDate,i.elapsed=this.elapsed,i.offset=t.extend({},this.offset),i.strftime=(s=this.offset,function(t){var e,i,n,a,h,l,r=t.match(/%(-|!)?[A-Z]{1}(:[^;]+;)?/gi);if(r)for(var c=0,f=r.length;c<f;++c){var u=r[c].match(/%(-|!)?([a-zA-Z]{1})(:[^;]+;)?/),p=(e=u[0],i=e.toString().replace(/([.?*+^$[\]\\(){}|-])/g,"\\$1"),new RegExp(i)),d=u[1]||"",v=u[3]||"",g=null;u=u[2],o.hasOwnProperty(u)&&(g=o[u],g=Number(s[g])),null!==g&&("!"===d&&(a=g,h=void 0,l=void 0,h="s",l="",(n=v)&&(1===(n=n.replace(/(:|;|\s)/gi,"").split(/\,/)).length?h=n[0]:(l=n[0],h=n[1])),g=Math.abs(a)>1?h:l),""===d&&g<10&&(g="0"+g.toString()),t=t.replace(p,g.toString()))}return t=t.replace(/%%/,"%")}),this.$el.trigger(i)}}),t.fn.tsioCountdown=function(){var s=Array.prototype.slice.call(arguments,0);return this.each(function(){var i=t(this).data("tsiocountdown-instance");if(void 0!==i){var o=e[i],a=s[0];n.prototype.hasOwnProperty(a)?o[a].apply(o,s.slice(1)):null===String(a).match(/^[$A-Z_][0-9A-Z_$]*$/i)?(o.setFinalDate.call(o,a),o.start()):t.error("Method %s does not exist on jQuery.tsioCountdown".replace(/\%s/gi,a))}else new n(this,s[0],s[1])})}}($);

      $(function(){
        $('.ws-period time').each(function(){
          var dateString = $(this).attr('datetime').replace(/\//g,'-') + 'T23:59:59.000';
          if(timezoneOffset){
            dateString += timezoneOffset;
          }
          var dateObj = new Date(dateString);
          $(this).tsioCountdown(dateObj, function(event) {
            $(this).html(event.strftime('%-Dd %Hh %Mm %Ss'));
          });
        });
      });
    };

    if(countDownsAvailable.length){
      if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.7)) {
        loadScript('//ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js', function(){
          jQueryTSIOWorkshop = jQuery.noConflict(true);
          initCountdowns(jQueryTSIOWorkshop);
        });
      } else {
        initCountdowns(jQuery);
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
